import React from "react";
import styles from "./index.module.css";

const Spacer = () => {
    return <div className={styles.spacer}>
        <div className={styles.line} />
    </div>;
}

export default Spacer;